import { FunctionComponent, useEffect, useState } from 'react';
import { StyledCell } from '../styles';
import { CellProps } from '../types';
import { EllipsisText } from 'components/tables/EllipsisText';
import { styled } from 'styled-components';
import { Text } from '@montel/montelpro-shared-components-v2';
import { v4 as uuidv4 } from 'uuid';
import { TableFriendlyTooltip } from 'components/tables/TableFriendlyTooltip';

export interface TextCellProps extends CellProps {
	text: string;
	color?: string;
	tooltipText?: string;
	withTooltip?: boolean;
}

const StyledTextWrapper = styled.div<{ $color: string }>`
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ $color, theme }) => theme.colors[$color] || $color};
`;

const TextCell: FunctionComponent<TextCellProps> = ({
	text = '',
	align = 'flex-start',
	justify = 'center',
	color = 'textDefault',
	offsetLeft,
	tooltipText,
	withTooltip = false,
}) => {
	const [id, setId] = useState<string>('');
	const tooltip = tooltipText || text;

	useEffect(() => {
		setId(uuidv4().replaceAll('-', ''));
	}, []);

	return (
		<StyledCell align={align} justify={justify} $offsetLeft={offsetLeft}>
			{withTooltip ? (
				<>
					<TableFriendlyTooltip id={id} />
					<StyledTextWrapper
						$color={color}
						data-tooltip-id={id}
						data-tooltip-content={tooltip}
					>
						<Text as={'span'} color={color}>
							{text}
						</Text>
					</StyledTextWrapper>
				</>
			) : (
				<EllipsisText as={'span'} size="sm" color={color}>
					{text}
				</EllipsisText>
			)}
		</StyledCell>
	);
};

export default TextCell;
